export const FEATURE_FLAG = {
  pwaPushPrimer: 'feature_ShowPushNotificationsPrimer',
  quotesResultsCustomPopup: 'feature_HealthQuoteResultCustomPopup',
  appleSSO: 'feature_AppleSSO',
  rateTracker: 'feature_RateTrackerLink',
  reviewStatusVisibility: 'feature_ReviewStatusVisibility',
  healthBupaStripeEnabled: 'feature_HealthBupaPaymentGatewayStripe',
  healthMedicareCardRedesign: 'feature_HealthMedicareCardRedesign',
  lifeJoinClubPlusModal: 'feature_LifeJoinClubPlusModal',
  energyJoinClubPlusModal: 'feature_EnergyJoinClubPlusModal',
  smartBillUpload: 'feature_SmartBillUpload',
  coreActions: 'feature_CoreActions',
  coreActionsGiftCard: 'feature_ShowCoreActionsGiftCard',
  hiHenryPopup: 'feature_HIHenryPopupEnabled',
  energyXSellRewardCampaign: 'feature_EnergyXSellRewardCampaign',
  energySaveResultsComparison: 'feature_EnergySaveResultsComparison',
  savingsTracker: 'feature_SavingsTracker',
  aiAdvisor: 'feature_AIAdvisor',
  // Gates the whole email bill-forwarding module. When off, the "Forward it to
  // us" tile redirects to the trail-check page instead of the forward-bill flow.
  emailForwardVault: 'feature_EmailForwardVault',
  openEnergyCdr: 'feature_OpenEnergyCdr',
  descopeLogin: 'feature_DescopeAuthFlows',
  descopMFA: 'feature_DescopeMFA',
  healthProgressIndicator: 'feature_HealthProgressIndicator',
  healthProductPriceCard: 'feature_HealthProductPriceCard',
  healthAcknowledgementAndReview: 'feature_HealthAcknowledgementAndReview',
  // HI-1421 — gates the standalone Product Details Page
  healthStandAlonePdp: 'feature_HealthStandAlonePdp',
  brazeDashboardBanners: 'feature_BrazeDashboardBanners',
  // HI-1551 — with healthStandAlonePdp, gates telling Salesforce "Application In Progress"
  // at step 1 instead of the first step after it
  healthApplicationInProgressStep1: 'feature_HealthApplicationInProgressStep1',
  // CLUB-483/480 — gates the Gmail bill-scraping module. On the vault upload
  // page, the "Connect your email" tile goes to the real consent screen (Gmail
  // OAuth) when on, and to the trail-check fake door when off.
  gmailBillScraping: 'feature_GmailBillScraping',
  applicationRedesignFields: 'feature_ApplicationRedesignFields'
}